import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaComposition.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                      */
//#region src/schema/SchemaComposition.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-e22666da"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaComposition.vue.js.map